import { render, staticRenderFns } from "./DeliverySignature.vue?vue&type=template&id=d35b397c&scoped=true&"
import script from "./DeliverySignature.vue?vue&type=script&lang=js&"
export * from "./DeliverySignature.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySignature.vue?vue&type=style&index=0&id=d35b397c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35b397c",
  null
  
)

export default component.exports